import { Backdrop, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";

interface ConfigLoadProps {
    loading: boolean;  // Opens it
    message?: string;  // Message passed in
}

const ConfigLoad: React.FC<ConfigLoadProps> = ({ loading, message }) => {
    const theme = useTheme();
    const globalLoading = useSelector((state: RootState) => state.appSlice.loadingState.loading);

    if (globalLoading) {
        return null;
    }

    // Show error message in red if not loading and message exists
    if (!loading && message) {
        return (
            <Backdrop
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                open={true}
            >
                <div className="modalUpdateProgress" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4}}>
                    <Typography
                        sx={{ color: theme.palette.error.main, fontWeight: 600, fontSize: "1.2rem" }}
                    >
                        {message}
                    </Typography>
                </div>
            </Backdrop>
        );
    }

    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            open={loading}
        >
            <div className="modalUpdateProgress" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4}}>
                <div className="loader" >
                </div>

                {message && (
                <Typography
                    sx={{ color: theme.palette.common.white}}
                >
                    {message}
                </Typography>
            )}
              
            </div>
            
        </Backdrop>
    );
};

export default ConfigLoad;